import React from 'react';
import Home from '../home/Home';

const ResetPassword = () => <Home isResetPassword={true} />

export default ResetPassword;